<p-dialog
  [(visible)]="visible"
  (onHide)="onClose()"
  [modal]="false"
  [header]="'MONITORING_POINTS' | translate"
  [style]="{ width: '800px' }"
  [maximizable]="true"
  [draggable]="true"
  [resizable]="true"
>
  <!-- Confirmation Dialog -->
<!--  <p-confirmDialog></p-confirmDialog>-->

  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <h3>{{ 'MONITORING_POINTS' | translate }}</h3>
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-chart-bar"
        class="p-button-text p-button-sm chart-button"
        (click)="onOpenAllPointsChart()"
        [pTooltip]="'SHOW_CHART' | translate">
      </button>
    </div>
  </ng-template>

  <div class="view-toggle">
    <button
      class="toggle-button"
      [class.active]="viewMode === 'points'"
      (click)="onViewModeChange('points')">
      {{ 'POINTS' | translate }}
    </button>
    <button
      class="toggle-button"
      [class.active]="viewMode === 'polygons'"
      (click)="onViewModeChange('polygons')">
      {{ 'POLYGONS' | translate }}
    </button>
  </div>

  <!-- Search Input -->
  <div class="monitoring-search-container">
    <input
      type="text"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange($event)"
      [placeholder]="'SEARCH' | translate"
      class="monitoring-search-input">
    <i class="pi pi-search search-icon"></i>
  </div>

  <div class="popup-content">
    <!-- Loading Indicator -->
    <div class="loading-container" *ngIf="isLoading">
      <div class="loader-wrapper">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #3388ff;"></i>
        <p style="margin-top: 10px; color: #666;">{{ 'LOADING' | translate }}</p>
      </div>
    </div>

    <div class="points-list" *ngIf="viewMode === 'points' && !isLoading">
      <!-- Monitoring Points -->
      <div *ngFor="let point of filteredPoints; let i = index"
           class="point-row"
           [class.selected]="selectedPointId?.toString() === point.id?.toString()">
        <div class="point-number">
          <span class="number-label">{{ i + 1 }}</span>
        </div>
        <div class="point-info" (click)="onGoToLocation(point)">
          <div class="point-name">{{ point.name || ('MONITORING_POINT' | translate) }}</div>
          <div class="point-subtitle" *ngIf="point.pointJson">{{ point.pointJson.lat?.toFixed(4) }}, {{ point.pointJson.lon?.toFixed(4) }}</div>
        </div>
        <div class="point-actions">
          <button
            pButton
            type="button"
            icon="pi pi-map-marker"
            class="p-button-text p-button-sm action-btn"
            [pTooltip]="'GO_TO_POINT' | translate"
            [disabled]="deletingPointId !== null"
            (click)="onZoomToPoint(point); $event.stopPropagation()">
          </button>
          <button
            pButton
            type="button"
            icon="pi pi-pencil"
            class="p-button-text p-button-sm action-btn"
            [pTooltip]="'Edit' | translate"
            [disabled]="deletingPointId !== null"
            (click)="onOpenWeatherForPoint(point); $event.stopPropagation()">
          </button>
          <button
            pButton
            type="button"
            [icon]="deletingPointId === point.id ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
            class="p-button-text p-button-sm action-btn delete-btn"
            [pTooltip]="'Delete' | translate"
            [disabled]="deletingPointId !== null"
            [loading]="deletingPointId === point.id"
            (click)="onDeletePoint(point); $event.stopPropagation()">
          </button>
        </div>
      </div>
    </div>

    <!-- Polygons List -->
    <div class="points-list" *ngIf="viewMode === 'polygons' && !isLoading">
      <div *ngFor="let polygon of filteredPolygons; let i = index"
           class="point-row"
           [class.selected]="selectedPolygonId === polygon.id"
           (click)="onGoToPolygon(polygon)">
        <div class="point-info">
          <div class="point-name">{{ i + 1 }}. {{ polygon.name }}</div>
        </div>
        <div class="point-actions">
          <button
            pButton
            type="button"
            icon="pi pi-map-marker"
            class="p-button-text p-button-sm action-btn"
            [pTooltip]="'GO_TO_POINT' | translate"
            [disabled]="deletingPointId !== null"
            (click)="onZoomToPoint(polygon); $event.stopPropagation()">
          </button>
          <button
            pButton
            type="button"
            icon="pi pi-pencil"
            class="p-button-text p-button-sm action-btn"
            [pTooltip]="'Edit' | translate"
            [disabled]="deletingPointId !== null"
            (click)="onOpenWeatherForPolygon(polygon); $event.stopPropagation()">
          </button>
          <button
            pButton
            type="button"
            [icon]="deletingPointId === polygon.id ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
            class="p-button-text p-button-sm action-btn delete-btn"
            [pTooltip]="'Delete' | translate"
            [disabled]="deletingPointId !== null"
            [loading]="deletingPointId === polygon.id"
            (click)="onDeletePolygon(polygon); $event.stopPropagation()">
          </button>
        </div>
      </div>
    </div>
  </div>

</p-dialog>
